import React from "react";
import { GreaterThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/GreaterThan";
import { DataDefinition } from "../../../rule-engine-core/Common/Data/DataDefinition";
import { BooleanDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { XExecutableTester } from "../XExecutableTester";
import { getIfElseSimpleRule } from "../../../Expressions/Testing/LogicData";
import { IntersectionRuleConfiguration } from "../../../rule-engine-core/Rule/Intersection/IntersectionRuleConfiguration";
import { IfThenExpression } from "../../../rule-engine-core/Expressions/Expressions/Logic/IfThenExpression";
import { StoryNode } from "../../StoryBook/StoryData";

const factory = (): IntersectionRuleConfiguration => {
    let ruleDefinition = new IntersectionRuleConfiguration();
    let inputDataDef = new DataDefinition();
    inputDataDef.fields.push(new BooleanDataDefinition("isMarried"));
    inputDataDef.fields.push(new NumberDataDefinition("age"));
    inputDataDef.fields.push(new NumberDataDefinition("income"));
    inputDataDef.fields.push(new BooleanDataDefinition("isEmployee"));

    ruleDefinition.inputData = () => inputDataDef;
    ruleDefinition.setTypeResults(new StringDataDefinition("name"));
    ruleDefinition.addXAxisExpression();

    if (ruleDefinition.xaxisExpressions.length !== 2) {
        throw new Error("intersection rule is not generated correctly. x axis expression is missing.");
    }

    let greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "income";
    greaterThan.value2.value = 5000;

    ruleDefinition.xaxisExpressions[0].expression = greaterThan;
    ruleDefinition.xaxisExpressions[1].variableName = "isMarried";

    ruleDefinition.addYAxisExpression();

    if (ruleDefinition.yaxisExpressions.length !== 2) {
        throw new Error("intersection rule is not generated correctly. y axis expression is missing.");
    }

    greaterThan = new GreaterThanExpression();
    greaterThan.value1.variableName = "age";
    greaterThan.value2.value = 25;

    ruleDefinition.yaxisExpressions[0].expression = greaterThan;
    ruleDefinition.yaxisExpressions[1].variableName = "isEmployee";

    ruleDefinition.results[0].resultExpression.value = "Jose Chacin";
    ruleDefinition.results[1].resultExpression.value = "Carl Hewitt";
    ruleDefinition.results[2].resultExpression.value = "Bruno Pereira";
    ruleDefinition.results[3].resultExpression.value = "Carlos";

    return ruleDefinition;
};

export const IntersectionTester = [
    new StoryNode(
        () => {
            let rule = factory();
            return <XExecutableTester executable={rule} />;
        },
        "Shared",
        "Tester",
        "Intersection",
        "Default",
    ),

    new StoryNode(
        () => {
            let rule = factory();
            rule.xaxisExpressions[1].expression = getIfElseSimpleRule().expression;

            let inputDataDef = new DataDefinition();
            inputDataDef.fields.push(new BooleanDataDefinition("isMarried"));
            inputDataDef.fields.push(new NumberDataDefinition("age"));
            inputDataDef.fields.push(new NumberDataDefinition("income"));
            inputDataDef.fields.push(new BooleanDataDefinition("isEmployee"));
            inputDataDef.fields.push(new BooleanDataDefinition("isContractor"));

            rule.inputData = () => {
                return inputDataDef;
            };

            rule.yaxisExpressions[0].expression = getIfElseSimpleRule().expression;

            let greaterThan = new GreaterThanExpression();
            greaterThan.value1.variableName = "age";
            greaterThan.value2.value = 25;
            (
                rule.yaxisExpressions[0].expression as IfThenExpression
            ).ifBranches[0].ifExpression.elements[0].subExpression = greaterThan;
            return <XExecutableTester executable={rule} />;
        },
        "Shared",
        "Tester",
        "Intersection",
        "IfThen",
    ),
];
